import { configureStore } from "@reduxjs/toolkit";
import AuthSlice from "../features/auth/AuthSlice";
import CategorySlice from "../features/category/CategorySlice";
import ItemSlice from "../features/item/ItemSlice";

import OrderSlice from "../features/order/OrderSlice";
import FilterSlice from "../features/filter/FilterSlice";

export const store = configureStore({
  reducer: {
    auth: AuthSlice,
    category: CategorySlice,
    item: ItemSlice,
    order: OrderSlice,
    filter: FilterSlice,
  },
});
